import {sendFeedBackAsync} from '../helpers/feedbackService';

export const sendFeedBack = () => {
    return (dispatch, getState) => {

        let feedback = getState().feedback;
        sendFeedBackAsync(feedback);
        dispatch(feedBackSent());
    }   
}

export const feedBackSent = () => {
    return {
        type: 'FEEDBACK_SENT'
    };

}

export const updateFeedback = (feedback) => {
    return {
        type: 'UPDATE_FEEDBACK',
        feedback: feedback
    };
}





